module.exports = __webpack_public_path__ + "img/2201.3ac698ba.svg";